export const cm2px = (cm, dpi) => {
  return Math.round((cm * dpi) / 2.54);
};
